import {tgxApi} from "../../../app/tgxApi";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {
    getAuthorizationHeader, getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {downloadFile} from "../../../helpers/utils/FileUtils";

export const stateCodeApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchAllStateCodes: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/state-codes/search?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['stateCode'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getStateCodeById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-state-codes-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['stateCodeById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createStateCode: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/state-codes/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['stateCode'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "State Code")
            },
        }),

        updateStateCode: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update-state-codes-by-id/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['stateCode', 'stateCodeById','userAuditableInfo'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "State Code")
            },
        }),

        deleteStateCodeByIdService: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-state-code-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['stateCode', 'stateCodeById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "State Code");
            },
        }),

        exportStateCodeData: build.query({
            query: (query) => {
                return {
                    url: `/export/state-codes`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("state Code"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),


    }),
});

export const {useCreateStateCodeMutation,
useSearchAllStateCodesQuery,
useDeleteStateCodeByIdServiceMutation,
useLazyExportStateCodeDataQuery,
useGetStateCodeByIdQuery,
useUpdateStateCodeMutation
}=stateCodeApi
